<script>import * as d3 from "d3";
import Configurator from "../lab/report/Configurator.svelte";
import ReportLauncher from "./ReportLauncher.svelte";
import { ReportConfigurationTags } from "../lab/report/schemas/configuration.const.js";
export let start;
export let end;
export let categories;
export let usage = "report";
let reportConfiguration = {
  range: {
    start: d3.timeDay.floor(new Date(start)).getTime(),
    end: d3.timeDay.ceil(new Date(end)).getTime(),
    type: "custom"
  }
};
const categoryMap = categories.reduce(
  (map, category) => {
    map[category.group].push(category);
    return map;
  },
  {
    sensor: [],
    observation: [],
    modeling: [],
    visual: [],
    nonevisual: []
  }
);
const getReportQuery = (reportConfiguration2) => `?start=${new Date(reportConfiguration2.range.start).toISOString()}&end=${new Date(reportConfiguration2.range.end).toISOString()}&type=${reportConfiguration2.range.type}&fixed=false`;
$:
  query = getReportQuery(reportConfiguration);
</script>

<div class="dialog">
	<Configurator bind:value={reportConfiguration} fixedRangeType={false} usage={usage==="report"?ReportConfigurationTags.DEFAULT : ReportConfigurationTags.EXPORT}/>
	<div class="report-launchers">
		{#each Object.keys(categoryMap) as categoryName}
			{#if categoryMap[categoryName].length > 0}
				<div class="tlmd-launcher-group {categoryName}">
					{#each categoryMap[categoryName] as definition}
						<ReportLauncher definition={Object.assign({},definition, { options:{ url: definition.options.url+ query+(definition.options.parameters ? '&'+definition.options.parameters : ''), target: usage}})} />
					{/each}
				</div>
			{/if}
		{/each}
	</div>
</div>

<style>
	div.dialog {
		font-family: 'Roboto';
	}
</style>
